import { combineReducers } from 'redux';
import {
  ActionsObservable,
  combineEpics,
  StateObservable
} from 'redux-observable';
import { catchError } from 'rxjs/operators';
import { AnyAction } from 'typescript-fsa';
import { HYDRATE } from 'next-redux-wrapper';
import questions, { questionsEpic, QuestionsState } from './questions';
import searchResults, {
  searchResultsEpic,
  SearchResultsState
} from './searchResults';
import videos, { videosEpic, VideosState } from './videos';
import siteSettings, {
  siteSettingsEpic,
  SiteSettingsState
} from './siteSettings';

export interface RootState {
  questions: QuestionsState;
  searchResults: SearchResultsState;
  videos: VideosState;
  siteSettings: SiteSettingsState;
}

const combinedReducer = combineReducers({
  questions,
  searchResults,
  videos,
  siteSettings
});

const rootReducer = (
  state: RootState | undefined,
  action: AnyAction
): RootState => {
  if (action.type === HYDRATE) {
    return {
      ...state,
      ...(action as AnyAction & { payload: RootState }).payload
    } as RootState;
  }
  return combinedReducer(state, action) as RootState;
};

export default rootReducer;

export const rootEpic = (
  action$: ActionsObservable<AnyAction>,
  store$: StateObservable<RootState>,
  dependencies: Record<string, unknown>
) => {
  return combineEpics(
    questionsEpic,
    searchResultsEpic,
    videosEpic,
    siteSettingsEpic
  )(action$, store$, dependencies).pipe(
    catchError((error, source) => {
      console.error(error);
      return source;
    })
  );
};
